export const clickLink = (link: string, newTab?: boolean) => {
  const element = document.createElement('a');
  element.setAttribute('href', link);

  if (newTab) element.setAttribute('target', '_blank');

  element.click();
  element.remove();
};
